"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _reactJss = require("react-jss");

var LockedstylesWithProps = function LockedstylesWithProps(props) {
  return {
    NavHorizontal_Top: {
      display: 'flex',
      position: 'fixed',
      width: '100%',
      top: '0px',
      height: props.Height,
      zIndex: props.ZIndex ? props.ZIndex : null
    },
    NavHorizontal_Bottom: {
      display: 'flex',
      position: 'fixed',
      width: '100%',
      bottom: '0px',
      height: props.Height,
      zIndex: props.ZIndex ? props.ZIndex : null
    }
  };
}; //eslint-disable-next-line


var Lockedstyles = {};
var styles = (0, _reactJss.createUseStyles)(function (theme) {
  return {
    NavHorizontal_Top: theme.NavHorizontal_Top,
    NavHorizontal_Bottom: theme.NavHorizontal_Bottom,
    NavHorizontal_Inner: theme.NavHorizontal_Inner,
    NavHorizontal_Inner_Init: {
      transition: 'none'
    }
  };
});
/**
 * Create a Fix Component to be used as a wrapper for the Top and Bottom Nav Bars
 */

var NavHorizontalBar = /*#__PURE__*/_react["default"].forwardRef(function NavHorizontalBar(props, ref) {
  var Position = props.Position,
      Show = props.Show,
      ZIndex = props.ZIndex,
      Height = props.Height,
      MaxWidth = props.MaxWidth,
      LeftRefComponentID = props.LeftRefComponentID,
      LeftWidthExpanded = props.LeftWidthExpanded,
      LeftWidthMinimized = props.LeftWidthMinimized,
      UpdateStatusLeft = props.UpdateStatusLeft,
      RightRefComponentID = props.RightRefComponentID,
      RightWidthExpanded = props.RightWidthExpanded,
      RightWidthMinimized = props.RightWidthMinimized,
      UpdateStatusRight = props.UpdateStatusRight,
      classExtendNavHorizontalBar = props.classExtendNavHorizontalBar,
      children = props.children,
      other = (0, _objectWithoutProperties2["default"])(props, ["Position", "Show", "ZIndex", "Height", "MaxWidth", "LeftRefComponentID", "LeftWidthExpanded", "LeftWidthMinimized", "UpdateStatusLeft", "RightRefComponentID", "RightWidthExpanded", "RightWidthMinimized", "UpdateStatusRight", "classExtendNavHorizontalBar", "children"]);
  var theme = (0, _reactJss.useTheme)();
  var classes = styles((0, _extends2["default"])({}, props, {
    theme: theme
  }));

  var _React$useState = _react["default"].useState(true),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      Init = _React$useState2[0],
      setInit = _React$useState2[1];

  var _React$useState3 = _react["default"].useState(0),
      _React$useState4 = (0, _slicedToArray2["default"])(_React$useState3, 2),
      PaddingLeft = _React$useState4[0],
      setPaddingLeft = _React$useState4[1];

  var _React$useState5 = _react["default"].useState(0),
      _React$useState6 = (0, _slicedToArray2["default"])(_React$useState5, 2),
      PaddingRight = _React$useState6[0],
      setPaddingRight = _React$useState6[1];

  var _React$useState7 = _react["default"].useState('100%'),
      _React$useState8 = (0, _slicedToArray2["default"])(_React$useState7, 2),
      MaxWidthFinal = _React$useState8[0],
      setMaxWidthFinal = _React$useState8[1]; //Adjusting width when window is resized


  var handleResize = _react["default"].useCallback(function () {
    var AppMaxWidth, PaddingLeftCalc, PaddingRightCalc, MaxWidthCalc;
    AppMaxWidth = MaxWidth; //Setting the maxWidth and padding of the NavBar

    if (LeftRefComponentID && document.getElementById(LeftRefComponentID)) {
      PaddingLeftCalc = document.getElementById(LeftRefComponentID).getBoundingClientRect().width;

      if (RightRefComponentID && document.getElementById(RightRefComponentID)) {
        PaddingRightCalc = document.getElementById(RightRefComponentID).getBoundingClientRect().width;

        if (AppMaxWidth === '100%') {
          //   MaxWidthCalc = window.innerWidth - PaddingLeftCalc - PaddingRightCalc;
          MaxWidthCalc = window.innerWidth;
        } else {
          //   MaxWidthCalc = parseFloat(AppMaxWidth) - PaddingLeftCalc - PaddingRightCalc;
          MaxWidthCalc = parseFloat(AppMaxWidth);
        }
      } else {
        if (AppMaxWidth === '100%') {
          //   MaxWidthCalc = window.innerWidth - PaddingLeftCalc;
          MaxWidthCalc = window.innerWidth;
        } else {
          //   MaxWidthCalc = parseFloat(AppMaxWidth) - PaddingLeftCalc;
          MaxWidthCalc = parseFloat(AppMaxWidth);
        }
      }
    } else {
      if (RightRefComponentID && document.getElementById(RightRefComponentID)) {
        PaddingLeftCalc = 0;
        PaddingRightCalc = document.getElementById(RightRefComponentID).getBoundingClientRect().width;

        if (AppMaxWidth === '100%') {
          //   MaxWidthCalc = window.innerWidth - PaddingLeftCalc - PaddingRightCalc;
          MaxWidthCalc = window.innerWidth;
        } else {
          //   MaxWidthCalc = parseFloat(AppMaxWidth) - PaddingLeftCalc - PaddingRightCalc;
          MaxWidthCalc = parseFloat(AppMaxWidth);
        }
      } else {
        if (AppMaxWidth === '100%') {
          MaxWidthCalc = window.innerWidth;
        } else {
          MaxWidthCalc = parseFloat(AppMaxWidth);
        }
      }
    }

    setPaddingLeft(PaddingLeftCalc);
    setPaddingRight(PaddingRightCalc);
    setMaxWidthFinal(MaxWidthCalc);
  }, [LeftRefComponentID, MaxWidth, RightRefComponentID]);

  var FinalCalcUpdate = _react["default"].useCallback(function () {
    var PaddingLeftCalc, PaddingRightCalc;

    if (UpdateStatusLeft === true) {
      PaddingLeftCalc = LeftWidthMinimized;
    } else {
      PaddingLeftCalc = LeftWidthExpanded;
    }

    if (UpdateStatusRight === true) {
      PaddingRightCalc = RightWidthMinimized;
    } else {
      PaddingRightCalc = RightWidthExpanded;
    }

    setPaddingLeft(PaddingLeftCalc);
    setPaddingRight(PaddingRightCalc);
  }, [UpdateStatusLeft, UpdateStatusRight, LeftWidthExpanded, LeftWidthMinimized, RightWidthExpanded, RightWidthMinimized]); //   Recalculating the Width and Padding when the Left or Right Components are changing


  _react["default"].useEffect(function () {
    FinalCalcUpdate();
  }, [UpdateStatusLeft, UpdateStatusRight, FinalCalcUpdate]); //Adding Window Resize Event Listener


  _react["default"].useEffect(function () {
    window.addEventListener('resize', handleResize);
    return function cleanup() {
      window.removeEventListener('resize', handleResize);
    };
  }, [handleResize]); //Setting the class to Init when Initializing (to avoid strange rendering) due to animation


  _react["default"].useEffect(function () {
    handleResize();
    setTimeout(function () {
      setInit(false);
    }, 200);
  }, [handleResize]); //Setting the final class and style based on props state


  var FinalStyle;

  if (Position === 'bottom') {
    FinalStyle = (0, _extends2["default"])({}, LockedstylesWithProps(props).NavHorizontal_Bottom, {
      maxWidth: MaxWidthFinal.toString().slice(-1) === '%' ? MaxWidthFinal : MaxWidthFinal.toString().slice(-2) === 'px' ? MaxWidthFinal : MaxWidthFinal + 'px',
      display: Show === false ? 'none' : null
    });
  } else {
    FinalStyle = (0, _extends2["default"])({}, LockedstylesWithProps(props).NavHorizontal_Top, {
      maxWidth: MaxWidthFinal.toString().slice(-1) === '%' ? MaxWidthFinal : MaxWidthFinal.toString().slice(-2) === 'px' ? MaxWidthFinal : MaxWidthFinal + 'px',
      display: Show === false ? 'none' : null
    });
  }

  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    ref: ref
  }, other, {
    className: Position === 'top' ? (0, _clsx["default"])(classes.NavHorizontal_Top) : (0, _clsx["default"])(classes.NavHorizontal_Bottom),
    style: FinalStyle
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: Init ? (0, _clsx["default"])(classes.NavHorizontal_Inner, classes.NavHorizontal_Inner_Init) : classes.NavHorizontal_Inner,
    style: {
      paddingLeft: PaddingLeft + 'px',
      paddingRight: PaddingRight + 'px',
      height: Height
    }
  }, children));
});

NavHorizontalBar.defaultProps = {
  Position: 'top',
  Show: true,
  ZIndex: null,
  Height: 60,
  MaxWidth: '100%',
  LeftRefComponentID: null,
  LeftWidthExpanded: null,
  LeftWidthMinimized: null,
  UpdateStatusLeft: false,
  RightRefComponentID: null,
  RightWidthExpanded: null,
  RightWidthMinimized: null,
  UpdateStatusRight: false,
  classExtendNavHorizontalBar: null
};
process.env.NODE_ENV !== "production" ? NavHorizontalBar.propTypes = {
  /**
   * Position
   * The position of the NavBar (top or bottom)
   */
  Position: _propTypes["default"].oneOf(['top', 'bottom']),

  /**
   * Show
   * Show or Hide the toolbar (true/false)
   */
  Show: _propTypes["default"].bool,

  /**
   * The z-index prop
   */
  ZIndex: _propTypes["default"].string,

  /**
   * Height
   * The height of the NavBar inluding the unit
   */
  Height: _propTypes["default"].string,

  /**
   * MaxWidth
   * the MaxWidth including the unit of the NavBar (Must be the same as the MaxWidth of the FlexSiteWrapper Component)
   */
  MaxWidth: _propTypes["default"].string,

  /**
   * LeftRefComponentID
   * The Component overlapping the SideBar on the left (for instance a sideBar)
   */
  LeftRefComponentID: _propTypes["default"].string,

  /**
   * The WidthExpanded prop of the left SideBar
   */
  LeftWidthExpanded: _propTypes["default"].string,

  /**
   * The WidthMinimized prop of the left SideBar
   */
  LeftWidthMinimized: _propTypes["default"].string,

  /**
   * The status of the LeftSideBar (Minimized =true/false)
   */
  UpdateStatusLeft: _propTypes["default"].bool,

  /**
   * RightRefComponentID
   * The Component overlapping the SideBar on the right (for instance a sideBar)
   */
  RightRefComponentID: _propTypes["default"].string,

  /**
   * The WidthExpanded prop of the left SideBar
   */
  RightWidthExpanded: _propTypes["default"].string,

  /**
   * The WidthMinimized prop of the left SideBar
   */
  RightWidthMinimized: _propTypes["default"].string,

  /**
   * The status of the LeftSideBar (Minimized =true/false)
   */
  UpdateStatusRight: _propTypes["default"].bool,

  /**
   * Extend the class
   */
  classExtendNavHorizontalBar: _propTypes["default"].string
} : void 0;
var _default = NavHorizontalBar;
exports["default"] = _default;